<script>
import { Scatter } from "vue-chartjs";
import Chart from "chart.js";
import * as ChartjsAnnotation from "chartjs-plugin-annotation";
import moment from "moment";

Chart.plugins.register(ChartjsAnnotation);

export default {
  name: "BezirksScatterplotNeuReff",
  extends: Scatter,
  props: [
    "bezirk",
    "color",
    "alle",
    "value",
    "formatter",
    "xaxis",
    "other_values",
    "other_values_instructions"
  ],
  mounted() {
    this.renderChart(this.chartjs_data, this.chartjs_options);

    var originalGetElementAtEvent = this.$options._chart.getElementAtEvent;
    this.$options._chart.getElementAtEvent = function() {
      return originalGetElementAtEvent
        .apply(this, arguments)
        .filter(function(e) {
          return e._datasetIndex == 0;
        });
    };
  },
  watch: {
    bezirk() {
      this.$nextTick(() => {
        this.$options._chart.config.data = this.chartjs_data;
        this.$options._chart.config.options = this.chartjs_options;
        this.$options._chart.update();
      });
    },
    value() {
      this.$nextTick(() => {
        this.$options._chart.config.data = this.chartjs_data;
        this.$options._chart.config.options = this.chartjs_options;
        this.$options._chart.update();
      });
    },
    xaxis() {
      this.$nextTick(() => {
        this.$options._chart.destroy();
        //            this.$options._chart.config.data.datasets = this.chartjs_data.datasets;
        //            this.$options._chart.config.options = this.chartjs_options;
        //            this.$options._chart.update();
        this.renderChart(this.chartjs_data, this.chartjs_options);
      });
    }
  },
  computed: {
    chartjs_data() {
      const cur = {
        label: this.bezirk[0].Bundesland,
        data: this.bezirk.map(d => ({
          x: this.xaxis == "day" ? d.day : d["bestätigte Fälle"],
          y: d[this.value],
          label: d[this.value],
          original_data: d
        })),
        showLine: true,
        fill: false,
        borderColor: this.color,
        pointRadius: 1
      };
      return {
        datasets: [cur]
          .concat(
            this.other_values.map((v, i) => ({
              label: v,
              data: this.bezirk.map(d => ({
                x: this.xaxis == "day" ? d.day : d["bestätigte Fälle"],
                y: d[v],
                original_data: d
              })),
              showLine: true,
              fill: i == 1 ? "1" : false,
              borderColor: "rgba(200, 200, 200, 0.5)",
              borderWidth: 1,
              pointRadius: 0
            }))
          )
          .concat(
            this.alle.length == 0
              ? []
              : [
                  {
                    label: this.alle[0].Bundesland,
                    data: this.alle.map(d => ({
                      x: this.xaxis == "day" ? d.day : d["bestätigte Fälle"],
                      y: d[this.value],
                      label: d[this.value],
                      original_data: d
                    })),
                    showLine: true,
                    fill: false,
                    borderColor: "#8e8e8e",
                    borderWidth: 1.5,
                    pointRadius: 0
                  }
                ]
          )
      };
    },
    chartjs_options() {
      return {
        //              maintainAspectRatio: false,
        aspectRatio: 2,

        annotation: { annotations: this.chartjs_annotations },
        legend: {
          display: false
        },
        animation: {
          duration: 0
        },
        scales: {
          xAxes:
            this.xaxis == "day"
              ? [
                  {
                    id: "xTimeScale",
                    type: "time",
                    time: {
                      unit: "day",
                      parser: "YYYY-MM-DD",
                      displayFormats: {
                        day: "D.M."
                      },
                      tooltipFormat: "D.M."
                    },
                    scaleLabel: {
                      display: false
                    }
                  }
                ]
              : [
                  {
                    type: "linear",
                    ticks: {
                      min: 1,
                      callback: value => this.$fmt(",.2r")(value),
                      maxTicksLimit: 4
                    }
                  }
                ],
          yAxes: [
            {
              type: "linear",
              ticks: {
                min: 0,
                max: 5,
                callback: value =>
                  [0, 1, 3, 5].indexOf(value) >= 0
                    ? this.$fmt(",.2r")(value)
                    : null,
                maxTicksLimit: 11
              }
            }
          ]
        },
        hover: {
          mode: "nearest"
        },
        tooltips: {
          mode: "index",
          intersect: false,
          filter: tooltipItem => tooltipItem.datasetIndex == 0,
          callbacks: {
            label: tooltipItem => {
              var b = this.chartjs_data.datasets[tooltipItem.datasetIndex].data[
                tooltipItem.index
              ].original_data;
              return [
                `${tooltipItem.xLabel}: ${this.$fmt(".2f")(b[this.value])}`,
                `(${this.$fmt(".2f")(b["Untere Grenze"])} – ${this.$fmt(".2f")(
                  b["Obere Grenze"]
                )})`
              ];
            }
          },
          displayColors: false
        },
        layout: {
          padding: {
            left: 0,
            top: 0,
            right: 0,
            bottom: 5
          }
        }
      };
    },
    nan_days() {
      return this.bezirk.filter(
        d => d.day > "2020-04-01" && isNaN(d[this.value])
      );
    },
    nan_days_sequences() {
      var r = [];
      var current = [];
      this.nan_days.forEach((d, i) => {
        if (
          i == 0 ||
          !moment(d.day)
            .subtract(1, "day")
            .isSame(moment(this.nan_days[i - 1].day))
        ) {
          if (current.length > 0) {
            current.push(this.nan_days[i - 1]);
            r.push(current);
          }
          current = [d];
        }
      });
      if (current.length == 1) {
        current.push(this.nan_days[this.nan_days.length - 1]);
        r.push(current);
      }
      return r;
    },
    chartjs_annotations() {
      return [
        {
          drawTime: "beforeDatasetsDraw",
          type: "line",
          mode: "horizontal",
          borderColor: "#8e8e8e",
          borderWidth: 1,
          scaleID: "y-axis-1",
          value: 1,
          label: {
            enabled: false
          }
        }
      ]
        .concat(
          this.nan_days.length > 0
            ? this.nan_days_sequences
                .map(nds => ({
                  drawTime: "beforeDatasetsDraw",
                  type: "box",
                  backgroundColor: "rgb(230,230,230)",
                  borderColor: "transparent",
                  borderWidth: 0,
                  xScaleID: "xTimeScale",
                  xMin: moment(nds[0].day, "YYYY-MM-DD")
                    .add(-0.5, "day")
                    .utcOffset(0),
                  xMax: moment(nds[1].day, "YYYY-MM-DD")
                    .add(0.5, "day")
                    .utcOffset(0)
                }))
                .concat([
                  {
                    drawTime: "beforeDatasetsDraw",
                    type: "line",
                    mode: "vertical",
                    scaleID: "xTimeScale",
                    value: moment(
                      this.nan_days.map(d => d).reverse()[0].day,
                      "YYYY-MM-DD"
                    ).utcOffset(0),
                    borderColor: "transparent",
                    label: {
                      enabled:
                        this.nan_days
                          .map(d => d.day)
                          .indexOf(this.bezirk[this.bezirk.length - 1].day) >=
                        0,
                      content: "zu wenige Fälle",
                      position: "top",
                      fontSize: 9,
                      backgroundColor: "transparent",
                      xAdjust: 35,
                      fontColor: "black"
                    }
                  }
                ])
            : []
        );
    }
  }
};
</script>
